import React from 'react';
import styled from 'styled-components';

import Admin from 'hive-admin';

import {
  ADMIN as FILTERS_ADMIN,
  SELLER as FILTERS_SELLER,
} from './filters';

import {
  ADMIN as COLUMNS_ADMIN,
  SELLER as COLUMNS_SELLER,
} from './columns';

import {
  ADMIN as FIELDS_ADMIN,
  SELLER as FIELDS_SELLER,
} from './fields';

const Description = styled.span`

`;

export default [
  ['ADMIN', {
    path: '/discountcodes',
  }],
  ['SELLER', {
    path: '/store/discountcodes',
    archiveLoadUrl: '/discountcodes',
  }],
].reduce(
  (pages, [forRole, config]) => {
    const [
      COLUMNS,
      FILTERS,
      FIELDS,
    ] = (
        forRole === 'ADMIN'
      ? [COLUMNS_ADMIN, FILTERS_ADMIN, FIELDS_ADMIN]
      : forRole === 'SELLER'
      ? [COLUMNS_SELLER, FILTERS_SELLER, FIELDS_SELLER]
      : []
    );
    pages.push(...Admin.compileFromLibrary(['GroupResource', {
      title: 'Discount Codes',
      // icon: 'gift',
      archiveConfig: {
        title: 'Discount Codes',
        label: 'Discount Codes',
        // icon: 'gift',
        hidden: [
          [
            'condition.checkViewer',
            'role', '!==', forRole,
          ],
        ],
        createButtonPath: `${config.path}/create`,
      },
      singleLoadUrl: '/discountcodes/:id',
      singleConfig: {
        hidden: true,
        alias: config.path,
        backButtonPaths: [config.path],
      },
      singleEditConfig: {
        renderHeaderDescription: props => (
          props.data
          ? (
              <Description>
                {`${
                  props.data.active ? 'ACTIVE' : 'INACTIVE'
                } / Used ${
                  props.data.usage
                } ${
                  props.data.usage === 1 ? 'time' : 'times'
                }`}
              </Description>
            )
          : null
        ),
        actions: [
          ['ActionSave', {
            handleSuccess: (data, props) => props.reload(),
          }],
          ...[
            ['activate', 'Activate', true],
            ['deactivate', 'Deactivate', false],
          ].map(([name, title, active]) => (
              ['ActionWithRequest', {
              name,
              title,
              ghost: true,
              skip: [
                props => !props.data || props.data.active === active,
              ],
              getRequestConfig: props => ({
                url: `discountcodes/${props.data._id}/activate`,
                data: { active },
                method: 'POST',
              }),
              handleSuccess: (data, props) => props.reload(),
            }]
          )),
          ['ActionDelete'],
        ],
      },
      singleCreateConfig: {
        headerTitle: 'New Discount Code',
      },
      redirect: [
        ['redirect.unauthorized'],
        [
          'redirect.checkViewer',
          'role', '!==', forRole,
            forRole === 'ADMIN'
          ? '/store/discountcodes'
          : forRole === 'SELLER'
          ? '/discountcodes'
          : null,
        ],
      ],
      columns: COLUMNS,
      filters: FILTERS,
      fields: FIELDS,
      ...config,
    }]).pages);
    return pages;
  },
  [],
);
